import React from 'react';

import TypographyBox from '../TypographyBox/TypographyBox';

const Paragraph = ({ content, ellipsis, textTransform, ...props }) => {
  return (
    <TypographyBox
      texttransform={textTransform}
      ellipsis={ellipsis}
      component="p"
      mb={0}
      mt={0}
      fontSize="14px"
      {...props}
    >
      {content}
    </TypographyBox>
  );
};

export default Paragraph;
